import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import UserAccessTime from "../user/AccessTime";
import VendorAccessTime from "../vendor/AccessTime/index"
import ManagerAccessTime from "../manager/AccessTime/index"
import CheckInOut from "../user/AccessTime/mobile/index";

const AccessTimePage = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const [isPWA, setIsPWA] = useState(false);
  useEffect(() => {
    let displayMode = "";

    if (window.matchMedia("(display-mode: standalone)").matches) {
      displayMode = "standalone";
      setIsPWA(true);
    } else {
      displayMode = "!!!!!!";
    }
  }, []);

  return (
    <div>
      {userProfile ? (
        currentUser.roles.includes("ROLE_VENDOR") ? (
          <VendorAccessTime />
        ) :
          currentUser.roles.includes("ROLE_MANAGER") ? (
            <ManagerAccessTime />
          ) : (
            isPWA ?
              <CheckInOut /> : <UserAccessTime />
          )
      ) : null}
    </div>
  );
};

export default AccessTimePage;
